<script>
    import { preventDefault } from 'svelte/legacy';

    import { environment } from "@app/store/envStore.svelte.js";
    import { authState } from "@app/store/authStore.svelte.js";
    import { uiState } from "@app/store/uiStore.svelte.js";
    import * as m from "@app/paraglide/messages.js";

    let canUseAudioDescription = $derived(authState.ad || !environment.online);
    let canUseLiveCaptioning = $derived(
        environment.online &&
            (authState.plan === "pro" || authState.plan === "enterprise"),
    );

    function saveUiSettings() {
        localStorage.setItem("cc-ui-settings", JSON.stringify(uiState));
    }
</script>

<h5 id="quickToolsSettingsTitle">{m.options_quicktools_title()}</h5>
<p id="quickToolsSettingsDesc" class="small text-muted">
    {m.options_quicktools_desc()}
</p>
<form class="mt-4" onsubmit={preventDefault(saveUiSettings)} aria-labelledby="quickToolsSettingsTitle" aria-describedby="quickToolsSettingsDesc">
    <div class="row">
        <div class="col-6">
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="summaryCheck"
                    bind:checked={uiState.quickTools.summary}
                    onchange={saveUiSettings}
                    aria-labelledby="summaryCheckLabel"
                />
                <label id="summaryCheckLabel" class="form-check-label" for="summaryCheck">{m.options_quicktools_info()}</label>
            </div>
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="searchCheck"
                    bind:checked={uiState.quickTools.search}
                    onchange={saveUiSettings}
                    aria-labelledby="searchCheckLabel"
                />
                <label id="searchCheckLabel" class="form-check-label" for="searchCheck"
                    >{m.options_quicktools_search_replace()}</label
                >
            </div>
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="spellCheckCheck"
                    bind:checked={uiState.quickTools.spellCheck}
                    onchange={saveUiSettings}
                    aria-labelledby="spellCheckCheckLabel"
                />
                <label id="spellCheckCheckLabel" class="form-check-label" for="spellCheckCheck"
                    >{m.options_quicktools_spell_check()}</label
                >
            </div>
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="timingCheck"
                    bind:checked={uiState.quickTools.timing}
                    onchange={saveUiSettings}
                    aria-labelledby="timingCheckLabel"
                />
                <label id="timingCheckLabel" class="form-check-label" for="timingCheck"
                    >{m.options_quicktools_timing_sync()}</label
                >
            </div>
            {#if canUseLiveCaptioning}
                <div class="mb-3 form-check form-switch">
                    <input
                        type="checkbox"
                        class="form-check-input"
                        id="liveCaptioningCheck"
                        bind:checked={uiState.quickTools.liveCaptioning}
                        onchange={saveUiSettings}
                        aria-labelledby="liveCaptioningCheckLabel"
                    />
                    <label id="liveCaptioningCheckLabel" class="form-check-label" for="liveCaptioningCheck"
                        >{m.options_quicktools_live_captioning()}</label
                    >
                </div>
            {/if}
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="qcCheck"
                    bind:checked={uiState.quickTools.qc}
                    onchange={saveUiSettings}
                    aria-labelledby="qcCheckLabel"
                />
                <label id="qcCheckLabel" class="form-check-label" for="qcCheck">{m.options_quicktools_qc_review()}</label>
            </div>
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="manualQcCheck"
                    bind:checked={uiState.quickTools.manualQc}
                    onchange={saveUiSettings}
                    aria-labelledby="manualQcCheckLabel"
                />
                <label id="manualQcCheckLabel" class="form-check-label" for="manualQcCheck"
                    >{m.options_quicktools_manual_qc()}</label
                >
            </div>
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="errorNavCheck"
                    bind:checked={uiState.quickTools.errorNav}
                    onchange={saveUiSettings}
                    aria-labelledby="errorNavCheckLabel"
                />
                <label id="errorNavCheckLabel" class="form-check-label" for="errorNavCheck"
                    >{m.options_quicktools_errors()}</label
                >
            </div>
        </div>
        <div class="col-6">
            {#if canUseAudioDescription}
                <div class="mb-3 form-check form-switch">
                    <input
                        type="checkbox"
                        class="form-check-input"
                        id="voicesCheck"
                        bind:checked={uiState.quickTools.voices}
                        onchange={saveUiSettings}
                        aria-labelledby="voicesCheckLabel"
                    />
                    <label id="voicesCheckLabel" class="form-check-label" for="voicesCheck"
                        >{m.options_quicktools_voices()}</label
                    >
                </div>
            {/if}
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="speakersCheck"
                    bind:checked={uiState.quickTools.speakers}
                    onchange={saveUiSettings}
                    aria-labelledby="speakersCheckLabel"
                />
                <label id="speakersCheckLabel" class="form-check-label" for="speakersCheck"
                    >{m.options_quicktools_speakers()}</label
                >
            </div>
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="tagsCheck"
                    bind:checked={uiState.quickTools.tags}
                    onchange={saveUiSettings}
                    aria-labelledby="tagsCheckLabel"
                />
                <label id="tagsCheckLabel" class="form-check-label" for="tagsCheck">{m.options_quicktools_tags()}</label>
            </div>
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="markersCheck"
                    bind:checked={uiState.quickTools.markers}
                    onchange={saveUiSettings}
                    aria-labelledby="markersCheckLabel"
                />
                <label id="markersCheckLabel" class="form-check-label" for="markersCheck"
                    >{m.options_quicktools_markers()}</label
                >
            </div>
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="videoFiltersCheck"
                    bind:checked={uiState.quickTools.videoFilters}
                    onchange={saveUiSettings}
                    aria-labelledby="videoFiltersCheckLabel"
                />
                <label id="videoFiltersCheckLabel" class="form-check-label" for="videoFiltersCheck"
                    >{m.options_quicktools_video_filters()}</label
                >
            </div>
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="notesCheck"
                    bind:checked={uiState.quickTools.notes}
                    onchange={saveUiSettings}
                    aria-labelledby="notesCheckLabel"
                />
                <label id="notesCheckLabel" class="form-check-label" for="notesCheck">{m.options_quicktools_notes()}</label>
            </div>
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="templatesCheck"
                    bind:checked={uiState.quickTools.templates}
                    onchange={saveUiSettings}
                    aria-labelledby="templatesCheckLabel"
                />
                <label id="templatesCheckLabel" class="form-check-label" for="templatesCheck"
                    >{m.options_quicktools_event_templates()}</label
                >
            </div>
            {#if environment.electron}
                <div class="mb-3 form-check form-switch">
                    <input
                        type="checkbox"
                        class="form-check-input"
                        id="mediaCheck"
                        bind:checked={uiState.quickTools.media}
                        onchange={saveUiSettings}
                        aria-labelledby="mediaCheckLabel"
                    />
                    <label id="mediaCheckLabel" class="form-check-label" for="mediaCheck"
                        >{m.options_quicktools_media()}</label
                    >
                </div>
            {/if}
        </div>
    </div>
</form>
